const images = {
  FULL_LOGO: 'https://res.cloudinary.com/mycreativeshop/image/upload/f_auto/public/mcs-logo-dark',
  SNAILBLAST:
    'https://res.cloudinary.com/snail-blast/image/upload/v1635821288/Logos/snailblast-icon-simple-color_pvmaov.svg'
};

export default images;
